import { useCustomerAPI } from '../../clients/customer-api/customer-api-client';
import { UserDocument, UserDriverLic } from '../../clients/quipli-service/user/user';
import Icon from '../../components/icons/icon';
import { Typography } from '../../components/typography/typography';

export const LicenseDetails = ({
  userLicenseDetails,
  userLicenseFile,
}: {
  userLicenseDetails?: UserDriverLic;
  userLicenseFile?: UserDocument;
}) => {
  const { downloadUserDocumentFile } = useCustomerAPI();

  const downloadUserLicenseFile = async (fileId: number) => {
    const url = await downloadUserDocumentFile(fileId);

    window.open(url, '_blank');
  };

  return (
    <>
      {userLicenseDetails && (
        <>
          <div className="flex justify-between">
            <Typography type="text-md" weight="bold" className="text-grey-500">
              Full Name
            </Typography>

            <Typography type="text-md" className="text-grey-600">
              {userLicenseDetails.fullName}
            </Typography>
          </div>

          <div className="flex justify-between">
            <Typography type="text-md" weight="bold" className="text-grey-500">
              Date of Birth
            </Typography>

            <Typography type="text-md" className="text-grey-600">
              {userLicenseDetails.dateOfBirth ? userLicenseDetails.dateOfBirth.toFormat('LL/dd/yyyy') : '-'}
            </Typography>
          </div>

          <div className="flex justify-between">
            <Typography type="text-md" weight="bold" className="text-grey-500">
              License Number
            </Typography>

            <Typography type="text-md" className="text-grey-600">
              {userLicenseDetails.driverLicNum}
            </Typography>
          </div>

          <div className="flex justify-between">
            <Typography type="text-md" weight="bold" className="text-grey-500">
              Expiration Date
            </Typography>

            <Typography type="text-md" className="text-grey-600">
              {userLicenseDetails.expirationDate.toFormat('LL/dd/yyyy')}
            </Typography>
          </div>

          <div className="flex justify-between">
            <Typography type="text-md" weight="bold" className="text-grey-500">
              Issuing State/Province
            </Typography>

            <Typography type="text-md" className="text-grey-600">
              {userLicenseDetails.state ? userLicenseDetails.state.name : '-'}
            </Typography>
          </div>
        </>
      )}

      {userLicenseFile && (
        <div className="flex justify-between">
          <Typography type="text-md" weight="bold" className="text-grey-500">
            Document Name
          </Typography>

          <div
            className="w-4/5 flex gap-3 items-center justify-end text-[var(--primary-color-500)] cursor-pointer"
            onClick={() => downloadUserLicenseFile(userLicenseFile.id)}
          >
            <Typography type="text-md" weight="medium">
              <span className="text-document-overflow">{userLicenseFile.fileName}</span>
            </Typography>
            <Icon icon="Download" size="medium" stroke="var(--primary-color-500)" />
          </div>
        </div>
      )}
    </>
  );
};
